var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import * as calcite from 'calcite-web/es6';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { environmentMIQ } from 'src/environment-miq';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
export class HomeComponent {
    constructor(elementRef, changeDectRef, httpClient) {
        this.changeDectRef = changeDectRef;
        this.httpClient = httpClient;
        this.showOverview = false;
        this.openVL = new Subject();
        this.openSV = new Subject();
        this.openShareLayer = new Subject();
        this.maxHeight = 768;
        this.sideOpen = true;
        this.isCompact = false;
        this.dataTableMinimized = false;
        this.dataTableLayerUniqueId = null;
        this.dataTableArr = [];
        this.basemapList = 'terrain,streets-vector,satellite,hybrid,topo-vector,gray-vector,osm';
        this.defaultBasemap = {
            "tileUrl": environmentMIQ.arcserverURL + "/rest/services/basemaps/penndotbasemap/MapServer/tile",
            "thumbnailTile": "/7/48/36",
            "tileTemplate": "/{level}/{row}/{col}",
            "title": "PennDOT"
        };
        this.basemapConfigs = [
            {
                tileUrl: "https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile",
                thumbnailTile: "/15/12358/9365",
                tileTemplate: "/{level}/{row}/{col}",
                title: "Elevation"
            },
            this.defaultBasemap,
            {
                tileUrl: "https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile",
                thumbnailTile: "/7/48/36",
                tileTemplate: "/{level}/{row}/{col}",
                title: "Topographic DRG"
            },
            {
                tileUrl: 'https://gis.penndot.pa.gov/img/rest/services/imagery/PEMA_2018/ImageServer/tile',
                thumbnailTile: '/13/3093/2346',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PEMA 2018'
            },
            {
                tileUrl: 'https://gis.penndot.pa.gov/img/rest/services/imagery/NAIP_2022/ImageServer/tile',
                thumbnailTile: '/13/3093/2346',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'NAIP 2022'
            }
        ];
        this.extentConfigs = [
            {
                toolTip: "Statewide",
                icon: "m28.531 12.656-.187-.531-1.156-.344-.344-.562-.187-1.437-.719-.312-.094-.344-.375-.312h-20.219v-1.625l-1.656.844 .219-.312-.656.5-1.375.594-.406 13.906 20.719.094h1.719l.313-.531.5-.25.781 .156 1.375-.562.094-.437 1.75-1.312-1.187-1.437h-.25l-.25-.875-.531-.062-.031-.75v-.375l.406-.25.188-.469-.375-.75.844-.844.719-1.25z",
                color: "white",
                extent: {
                    center: [-77.6362661695295, 40.92039887644528],
                    zoom: 8
                },
                extentType: "static",
                label: "Statewide Extent"
            }
        ];
        this.selectedLayers = [];
        this.layerIdsToBeAdded = [];
        this.childTables = [];
        this.printActive = false;
        this.printOpen = true;
        this.printReady = false;
        this.layerUpdates = [];
        this.identifyDisabledFor = [];
        elementRef.nativeElement.classList.add('flex-display', 'flex-col', 'flex-height-fix', 'height-wrap');
    }
    get isLoggedIn() {
        return this.navMenuRef && this.navMenuRef.isLoggedIn;
    }
    get isInternal() {
        return this.navMenuRef && this.navMenuRef.isInternal;
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setBasemap();
            this.constructExtent();
            this.setupBasemapSwitcher();
            this.importExternalMap.nativeElement.addEventListener('done', _ => this.closeImportExternalMapWinodw());
            window.addEventListener('addingMapcoreLayersToMap', (event) => __awaiter(this, void 0, void 0, function* () {
                if (event) {
                    this.selectedLayers = yield Promise.all(event.detail.map((l) => __awaiter(this, void 0, void 0, function* () {
                        const filterType = this.defaults && this.defaults.length ? 'defaults' : 'filter';
                        let extraFilters = [];
                        const env = window.environment || 'local';
                        const filterConfig = yield this.httpClient.get(`./static/filter-config.json?cb=${new Date().valueOf().toString().slice(0, -7)}`).toPromise();
                        for (let extraFilter of Object.keys(filterConfig[env])) {
                            if (Array.isArray(filterConfig[env][extraFilter]) && filterConfig[env][extraFilter].includes(l.id)) {
                                extraFilters.push({ name: extraFilter, value: this.getDefaultExtraFilterValue(extraFilter) });
                            }
                        }
                        return Object.assign({}, l, { filterType, extraFilters });
                    })));
                    this.filterLayerOptionsWindow.nativeElement.open();
                    this.layerFilter.nativeElement.layerId = null;
                }
            }));
            this.layerFilter.nativeElement.addEventListener('onapply', (event) => {
                this.filterLayer.bind(this);
                this.filterLayer(event);
            });
            this.layerFilter.nativeElement.addEventListener('ondone', () => {
                this.filteringLayer = null;
                setTimeout(() => {
                    this.filterLayer.bind(this);
                    this.filterLayer(null);
                }, 50);
            });
            this.layerFilterWindow.nativeElement.addEventListener('openChange', open => {
                if (!open.detail) {
                    this.filteringLayer = null;
                    setTimeout(() => {
                        this.filterLayer.bind(this);
                        this.filterLayer(null);
                    }, 100);
                }
            });
            this.layerFilter.nativeElement.addEventListener('onlayerdata', e => {
                let name = e.detail.name;
                if (this.filteringLayer && this.filteringLayer.mapcoreProps) {
                    name = this.filteringLayer.mapcoreProps.name;
                }
                this.layerFilterWindow.nativeElement.windowTitle = `Layer Filter - ${name}`;
            });
            this.layerFilter.nativeElement.addEventListener('onboundarysourcechanged', e => {
                if (e.detail === 'draw') {
                    this.disableIdentify({ key: 'geographicFilter', disable: true });
                    this.layerFilterWindow.nativeElement.width = 550;
                    this.layerFilterWindow.nativeElement.height = 400;
                }
                else {
                    this.disableIdentify({ key: 'geographicFilter', disable: false });
                    this.layerFilterWindow.nativeElement.width = 960;
                    this.layerFilterWindow.nativeElement.height = 700;
                }
            });
            this.layerSpatial.nativeElement.addEventListener('onboundarysourcechanged', e => {
                if (e.detail === 'draw') {
                    this.disableIdentify({ key: 'spatialQuery', disable: true });
                }
                else {
                    this.disableIdentify({ key: 'spatialQuery', disable: false });
                }
            });
            this.layerSpatial.nativeElement.addEventListener('onapply', (e) => {
                this.spatialNotification(e.detail.results);
                if (!e.detail.isNewLayer) {
                    this.legendRef.nativeElement.refreshTree(true);
                }
            });
            this.bufferWindow.nativeElement.addEventListener('openChange', open => {
                this.buffer.nativeElement.active = open.detail;
            });
            this.buffer.nativeElement.addEventListener('buffered', (e) => {
                if (e.detail) {
                    this.bufferWindow.nativeElement.close();
                }
            });
            calcite.dropdown();
            this.identifyWindow.nativeElement.addEventListener('status', status => {
                this.isLoading = status.detail === 'loading';
            });
            this.identifyWindow.nativeElement.addEventListener('featureUpdated', (event) => {
                this.identifyFeatureUpdated(event.detail);
            });
            this.mapRef.nativeElement.MapService.mapStatus.subscribe(status => {
                this.isLoading = status === 'loading';
                this.changeDectRef.detectChanges();
            });
            this.globalFilterWindow.nativeElement.addEventListener('openChange', open => {
                this.globalFilter.nativeElement.active = open.detail;
            });
            this.globalFilter.nativeElement.addEventListener('activeChange', active => {
                if (!active.detail) {
                    this.globalFilterWindow.nativeElement.close();
                }
            });
            this.mapRef.nativeElement.AoiService.highlightColor = {
                color: [0, 0, 0, 0],
                outlineColor: [0, 0, 0]
            };
            this.print.nativeElement.addEventListener('onoutputloaded', e => {
                if (!this.printOpen) {
                    this.printReady = true;
                }
            });
            this.exportMapWindowRef.nativeElement.addEventListener('openChange', open => {
                this.exportMapRef.nativeElement.active = open.detail;
            });
            this.exportMapRef.nativeElement.addEventListener('onclose', open => {
                this.exportMapWindowRef.nativeElement.close();
            });
            this.dataTable.nativeElement.addEventListener('closeTab', closedLayerId => {
                const index = this.dataTableArr.findIndex(x => x.layerId === closedLayerId.detail);
                if (index > -1) {
                    this.dataTableArr.splice(index, 1);
                }
                if (!this.dataTableArr.length) {
                    this.dataTable.nativeElement.opened = false;
                }
            });
            this.dataTable.nativeElement.addEventListener('ondraw', () => {
                this.disableIdentify({ key: 'dataTable', disable: true });
            });
            this.dataTable.nativeElement.addEventListener('ondrawcomplete', () => {
                this.disableIdentify({ key: 'dataTable', disable: false });
            });
            this.dataTable.nativeElement.addEventListener('openEditor', (e) => {
                this.openEditorWindow(e.detail.objectId ? 'edit' : 'add', e.detail.layerId, e.detail.objectId);
            });
            this.shareMap.nativeElement.addEventListener('closeShareMap', open => {
                this.shareMapWindow.nativeElement.close();
            });
            this.shareMap.nativeElement.addEventListener('openSaveMap', map => {
                this.saveMapWindow.nativeElement.open();
            });
            this.unshareMap.nativeElement.addEventListener('closeUnshareMap', open => {
                this.unshareMapWindow.nativeElement.close();
            });
            this.imageWindow.nativeElement.addEventListener('openChange', open => {
                if (!open.detail) {
                    this.imageGallery.nativeElement.imageSources = null;
                    this.imageGallery.nativeElement.videoSource = null;
                }
            });
            this.recordEditorWindowRef.nativeElement.addEventListener('openChange', open => {
                this.recordEditorRef.nativeElement.active = open.detail;
            });
            this.recordEditorRef.nativeElement.addEventListener('isComplete', (e) => {
                if (!e.detail || e.detail.shouldClose) {
                    this.recordEditorWindowRef.nativeElement.close();
                }
                if (e.detail && e.detail.saved && e.detail.esriLayerId) {
                    const esriLayer = this.mapRef.nativeElement.LayerService.getExistingEsriLayerById(e.detail.esriLayerId);
                    if (esriLayer) {
                        esriLayer.refresh();
                        this.identifyWindow.nativeElement.refresh();
                        if (this.dataTable.nativeElement.opened) {
                            this.dataTable.nativeElement.refreshGrid();
                        }
                    }
                }
            });
            this.recordEditorRef.nativeElement.addEventListener('selectingLatLong', (e) => {
                this.disableIdentify({ key: 'recordEditor', disable: e.detail });
                if (e.detail) {
                    this.recordEditorWindowInfo = {
                        height: this.recordEditorWindowRef.nativeElement.height,
                        width: this.recordEditorWindowRef.nativeElement.width,
                        top: this.recordEditorWindowRef.nativeElement.top,
                        left: this.recordEditorWindowRef.nativeElement.left,
                        minHeight: this.recordEditorWindowRef.nativeElement.minHeight
                    };
                    this.recordEditorWindowRef.nativeElement.minHeight = 200;
                    this.recordEditorWindowRef.nativeElement.height = 200;
                    this.recordEditorWindowRef.nativeElement.width = 600;
                    this.recordEditorWindowRef.nativeElement.top = 100;
                    this.recordEditorWindowRef.nativeElement.left = 100;
                }
                else {
                    this.recordEditorWindowRef.nativeElement.minHeight = 400;
                    this.recordEditorWindowRef.nativeElement.height = 800;
                    this.recordEditorWindowRef.nativeElement.width = 600;
                    this.recordEditorWindowRef.nativeElement.top = 100;
                    this.recordEditorWindowRef.nativeElement.left = 300;
                }
            });
            this.recordEditorWindowInfo = {
                height: this.recordEditorWindowRef.nativeElement.height,
                width: this.recordEditorWindowRef.nativeElement.width,
                top: this.recordEditorWindowRef.nativeElement.top,
                left: this.recordEditorWindowRef.nativeElement.left,
                minHeight: this.recordEditorWindowRef.nativeElement.minHeight
            };
            this.navMenuRef.authRef.nativeElement.user.subscribe(user => {
                if (user) {
                    this.user = user;
                }
                else {
                    this.user = null;
                }
            });
            this.mapInfoContainerRef.nativeElement.addEventListener('exitCompactViewEvent', exit => {
                this.closeCompactLegend();
            });
        });
    }
    getDefaultExtraFilterValue(extraFilterName) {
        let extraFilterValue = null;
        switch (extraFilterName) {
            case 'NOCO_VS_PAYROLL':
                extraFilterValue = false;
                break;
            case 'SAP_REMAINING_VS_COMPLETED':
                extraFilterValue = {
                    remaining: false,
                    yearType: 'fy'
                };
                break;
            case 'PLANYEAR_SEALCOAT':
                extraFilterValue = {
                    yearType: 'fy',
                    sealCoat: true
                };
                break;
            case 'SEALCOAT':
                extraFilterValue = {
                    sealCoat: true
                };
                break;
            case "DATERANGE":
                extraFilterValue = {
                    from: '',
                    to: ''
                };
                break;
            default:
                break;
        }
        return extraFilterValue;
    }
    closeMinMax() {
        this.minMaxScaleWindow.nativeElement.close();
    }
    setFilters() {
        this.layerFilter.nativeElement.layerId = null;
        this.filterLayerOptionsWindow.nativeElement.close();
        const showAllLayers = this.selectedLayers.filter(l => l.filterType === 'showAll');
        if (showAllLayers.length) {
            this.addLayers(showAllLayers);
        }
        this.applyDefaultsLayers(this.selectedLayers.filter(l => l.filterType === 'defaults'));
        this.selectedLayers = this.selectedLayers.filter(l => l.filterType === 'filter');
        this.layerIdsToBeAdded = this.selectedLayers.map(l => l.id);
        this.filterLayer(null);
    }
    buildQuery(layer, includeCyFy = false) {
        let query = null;
        if (layer.extraFilters.length) {
            if (layer.extraFilters.length > 1) {
                query = { operator: 'AND', subqueries: layer.extraFilters.map(filter => this.buildFilter(filter, layer, query, includeCyFy)) };
            }
            else {
                query = this.buildFilter(layer.extraFilters[0], layer, query, includeCyFy);
            }
        }
        if (query && query.subqueries && query.subqueries.length) {
            query.subqueries = query.subqueries.filter(x => (x.field && x.value) || (x.subqueries && x.subqueries.length > 0));
        }
        return query;
    }
    buildFilter(extraFilter, layer, query, includeCyFy = false) {
        if (!query) {
            query = { operator: 'AND', subqueries: [] };
        }
        switch (extraFilter.name) {
            case 'NOCO_VS_PAYROLL':
                if (extraFilter.value) {
                    query.subqueries.push({
                        field: 'IS_NO_CO_SUM_RECORD',
                        operator: '=',
                        value: 'T'
                    });
                }
                else {
                    query.subqueries.push({
                        field: 'IS_NO_CO_SUM_RECORD',
                        operator: '=',
                        value: 'F'
                    });
                }
                break;
            case 'SAP_REMAINING_VS_COMPLETED':
                if (extraFilter.value.remaining) {
                    query.subqueries.push({
                        field: 'IS_NO_CO',
                        operator: '=',
                        value: 'F'
                    });
                }
                else if (includeCyFy && extraFilter.value.yearType && extraFilter.value.yearType === 'fy') {
                    query.subqueries.push({
                        field: 'MAINT_FY',
                        operator: '>=',
                        value: '{currentFiscalYear}'
                    });
                }
                else if (includeCyFy && extraFilter.value.yearType && extraFilter.value.yearType === 'cy') {
                    query.subqueries.push({
                        field: 'CALENDAR_YEAR',
                        operator: '>=',
                        value: '{currentYear}'
                    });
                }
                break;
            case 'PLANYEAR_SEALCOAT':
                if (includeCyFy && extraFilter.value.yearType && extraFilter.value.yearType === 'fy') {
                    query.subqueries.push({
                        field: 'fy_plan_year_no',
                        operator: '=',
                        value: '{replaceYear}'
                    });
                }
                else {
                    query.subqueries.push({
                        field: 'cy_plan_year_no',
                        operator: '=',
                        value: '{replaceYear}'
                    });
                }
                if (!extraFilter.value.sealCoat) {
                    if (layer.name.toLocaleLowerCase().includes('mpms')) {
                        query.subqueries.push({
                            field: 'IMPROVEMENT_CODE',
                            operator: !extraFilter.value.sealCoat ? "NOT IN" : "IS NOT NULL",
                            value: !extraFilter.value.sealCoat ? "00037" : null
                        });
                    }
                    else if (layer.name.toLocaleLowerCase().includes('sap')) {
                        query.subqueries.push({
                            field: 'ASSEMBLY',
                            operator: !extraFilter.value.sealCoat ? "NOT IN" : "IS NOT NULL",
                            value: !extraFilter.value.sealCoat ? "712401,712404" : null
                        });
                    }
                }
                break;
            case 'SEALCOAT':
                if (!extraFilter.value.sealCoat) {
                    if (layer.name.toLocaleLowerCase().includes('mpms')) {
                        query.subqueries.push({
                            field: 'IMPROVEMENT_CODE',
                            operator: !extraFilter.value.sealCoat ? "NOT IN" : "IS NOT NULL",
                            value: !extraFilter.value.sealCoat ? "00037" : null
                        });
                    }
                    else if (layer.name.toLocaleLowerCase().includes('sap')) {
                        query.subqueries.push({
                            field: 'ASSEMBLY',
                            operator: !extraFilter.value.sealCoat ? "NOT IN" : "IS NOT NULL",
                            value: !extraFilter.value.sealCoat ? "712401,712404" : null
                        });
                    }
                }
                break;
            case 'DATERANGE':
                let today = new Date().toISOString().split("T")[0];
                query.subqueries.push({
                    field: 'TIME_STAMP',
                    operator: '>=',
                    value: extraFilter.value.from ? extraFilter.value.from : today
                });
                query.subqueries.push({
                    field: 'TIME_STAMP',
                    operator: '<=',
                    value: extraFilter.value.to ? extraFilter.value.to : today
                });
                break;
            default:
                break;
        }
        return query;
    }
    addLayers(layers) {
        return __awaiter(this, void 0, void 0, function* () {
            const layerAddPromises = [];
            for (const layer of layers) {
                const layerQuery = this.buildQuery(layer);
                layerAddPromises.push(this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([{ id: layer.id }], layerQuery).then(l => {
                    const addedLayer = l[0];
                    const lastFilters = layer.extraFilters.filter(ef => ef.name === 'SAP_REMAINING_VS_COMPLETED' || ef.name === 'PLANYEAR_SEALCOAT');
                    if (lastFilters.length) {
                        // There will only be one for now
                        const field = lastFilters[0].value.yearType === 'fy' ? 'MAINT_FY' : 'CALENDAR_YEAR';
                        if (field === 'MAINT_FY') {
                            if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.field && addedLayer.mapcoreProps.parentQuery.field.toUpperCase() === 'CALENDAR_YEAR') {
                                addedLayer.mapcoreProps.parentQuery.field = field;
                                addedLayer.mapcoreProps.parentQuery.value = '{currentFiscalYear}';
                            }
                            else if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.field) {
                                if (addedLayer.mapcoreProps.parentQuery.field.toLowerCase() === 'cy_plan_year_no') {
                                    addedLayer.mapcoreProps.parentQuery.field = 'fy_plan_year_no';
                                    if (addedLayer.mapcoreProps.parentQuery.operator !== 'BETWEEN') {
                                        addedLayer.mapcoreProps.parentQuery.value = '{currentFiscalYear}';
                                    }
                                }
                            }
                            else if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.subqueries) {
                                for (const q of addedLayer.mapcoreProps.parentQuery.subqueries) {
                                    if (q.field && q.field.toUpperCase() === 'CALENDAR_YEAR') {
                                        q.field = field;
                                        q.value = '{currentFiscalYear}';
                                    }
                                    else if (q.field && q.field.toLowerCase() === 'cy_plan_year_no') {
                                        q.field = 'fy_plan_year_no';
                                        if (q.operator !== 'BETWEEN') {
                                            q.value = '{currentFiscalYear}';
                                        }
                                    }
                                }
                            }
                        }
                        else if (field === 'CALENDAR_YEAR') {
                            if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.field && addedLayer.mapcoreProps.parentQuery.field.toUpperCase() === 'MAINT_FY') {
                                addedLayer.mapcoreProps.parentQuery.field = field;
                                addedLayer.mapcoreProps.parentQuery.value = '{currentYear}';
                            }
                            else if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.field) {
                                if (addedLayer.mapcoreProps.parentQuery.field.toLowerCase() === 'fy_plan_year_no') {
                                    addedLayer.mapcoreProps.parentQuery.field = 'cy_plan_year_no';
                                    if (addedLayer.mapcoreProps.parentQuery.operator !== 'BETWEEN') {
                                        addedLayer.mapcoreProps.parentQuery.value = '{currentYear}';
                                    }
                                }
                            }
                            else if (addedLayer.mapcoreProps.parentQuery && addedLayer.mapcoreProps.parentQuery.subqueries) {
                                for (const q of addedLayer.mapcoreProps.parentQuery.subqueries) {
                                    if (q.field && q.field.toUpperCase() === 'MAINT_FY') {
                                        q.field = field;
                                        q.value = '{currentYear}';
                                    }
                                    else if (q.field && q.field.toLowerCase() === 'fy_plan_year_no') {
                                        q.field = 'cy_plan_year_no';
                                        if (q.operator !== 'BETWEEN') {
                                            q.value = '{currentYear}';
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (addedLayer.mapcoreProps.query && addedLayer.mapcoreProps.query.subqueries && addedLayer.mapcoreProps.query.subqueries.length && addedLayer.mapcoreProps.query.subqueries.length > 0) {
                        addedLayer.mapcoreProps.query.subqueries = addedLayer.mapcoreProps.query.subqueries.filter(x => !(x.field.indexOf('plan_year_no') > -1 && x.value === '{replaceYear}'));
                    }
                    let finalQuery = Object.assign({}, addedLayer.mapcoreProps.query);
                    if (addedLayer.mapcoreProps.parentQuery) {
                        finalQuery = this.mapRef.nativeElement.ToSqlStringService.addFilter(Object.assign({}, addedLayer.mapcoreProps.query), addedLayer.mapcoreProps.parentQuery);
                    }
                    if (!finalQuery) {
                        finalQuery = {};
                    }
                    addedLayer.sublayers.forEach(sublayer => {
                        sublayer.source.dataSource.query = JSON.stringify(finalQuery);
                    });
                }));
            }
            yield Promise.all(layerAddPromises);
        });
    }
    applyDefaultsLayers(layers) {
        return __awaiter(this, void 0, void 0, function* () {
            if (layers && layers.length) {
                yield this.addLayers(layers);
                const searchCriteria = [];
                const districts = this.defaults.filter(d => d.startsWith('district'));
                const counties = this.defaults.filter(d => d.startsWith('county'));
                if (districts || counties) {
                    if (!counties.length && districts.length) {
                        // Use districts
                        searchCriteria.push({
                            type: 'district',
                            districtNumbers: districts.map(county => county.replace('district-', ''))
                        });
                    }
                    else if (counties.length) {
                        // Use counties
                        searchCriteria.push({
                            type: 'county',
                            countyCodes: counties.map(county => county.replace('county-', ''))
                        });
                    }
                    this.mapRef.nativeElement.AoiService.setSearchCriterias(searchCriteria);
                    yield this.mapRef.nativeElement.AoiService.filterLayers(layers.map(layer => layer.id));
                }
            }
        });
    }
    filterLayer(event) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.filterLayerCatch) {
                    this.layerFilterWindow.nativeElement.close();
                    this.layerFilterWindow.nativeElement.windowTitle = 'Layer Filter';
                    this.filterLayerCatch = setTimeout(() => this.filterLayerCatch = null, 500);
                    if (event) {
                        if (event.detail && event.detail.esriLayer) {
                            return;
                        }
                        if (event.detail && event.detail.data) {
                            this.layerFilter.nativeElement.extraQuery = event.detail.data.query;
                            const layerId = event.detail.id;
                            if (this.layerIdsToBeAdded.indexOf(layerId) >= 0) {
                                const layerSettings = {
                                    id: layerId,
                                    query: event.detail.data.query,
                                    joinColumns: event.detail.data.joinColumns,
                                    childColumns: event.detail.data.childColumns,
                                    exportJoinFilterParams: event.detail.data.exportJoinFilterParams,
                                    parentQuery: event.detail.data.parentQuery,
                                    geometryString: event.detail.data.geometryString
                                };
                                this.layerFilter.nativeElement.layerId = null; //Force a reset of the layerId
                                yield this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([layerSettings]);
                                var index = this.layerIdsToBeAdded.indexOf(layerId);
                                if (index !== -1)
                                    this.layerIdsToBeAdded.splice(index, 1);
                                const esriLayer = this.getEsriLayer(layerId);
                                if (event.detail.data.geometryString && esriLayer.mapcoreProps.spatialQueryParams === undefined) {
                                    this.layerSpatial.nativeElement.getSpatialQueryService.applyGeographicFilter(esriLayer, event.detail.data.geometryString);
                                }
                            }
                        }
                    }
                    if (this.selectedLayers.length > 0) {
                        const nextLayer = this.selectedLayers.shift();
                        this.layerFilter.nativeElement.extraQuery = this.buildQuery(nextLayer, true);
                        this.layerFilter.nativeElement.layerId = null; //Force a reset of the layerId
                        this.layerFilter.nativeElement.layerId = nextLayer.id;
                        this.layerFilterWindow.nativeElement.open();
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    getEsriLayer(layerId) {
        return this.mapRef.nativeElement.map.layers.items.find(layer => layer.mapcoreProps && layer.mapcoreProps.parentId === layerId);
    }
    closeFilterLayerOptionsWindow() {
        this.filterLayerOptionsWindow.nativeElement.close();
    }
    constructExtent() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.extentRef.nativeElement.ready;
            for (let extentConfig of this.extentConfigs) {
                this.extentRef.nativeElement.addExtentConfiguration(extentConfig);
            }
        });
    }
    setBasemap() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mapRef.nativeElement.ready;
            yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
        });
    }
    setupBasemapSwitcher() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.basemapSwitcherRef.nativeElement.ready;
            this.basemapSwitcherRef.nativeElement.addBasemaps(this.basemapList, this.basemapConfigs);
        });
    }
    onOptionSelect(event) {
        return __awaiter(this, void 0, void 0, function* () {
            let target = event.detail.target;
            if (target.tagName.toLowerCase() !== 'button') {
                while (target.tagName.toLowerCase() !== 'button' && target.tagName.toLowerCase() !== 'nav') {
                    target = target.parentElement;
                }
                if (target.tagName.toLowerCase() === 'nav') {
                    return;
                }
            }
            const layerId = event.detail.layerId;
            const esriLayer = this.getLayerByUniqueId(layerId);
            const exportLayerRef = this.exportLayer.nativeElement.getComponentReference();
            const layer = this.mapRef.nativeElement.map.findLayerById(event.detail.layerId);
            let rootQuery = { operator: 'AND', subqueries: [] };
            const buttonClass = target.className
                .replace('dropdown-link', '')
                .replace('spatial', '')
                .replace('icon-ui-filter', '')
                .replace('icon-ui-close', '')
                .replace('btn btn-transparent', '')
                .replace('icon-ui-blue', '')
                .trim().toLowerCase();
            switch (buttonClass) {
                case "save-option":
                    this.saveLayerTool.nativeElement.layerId = layerId;
                    this.saveLayerWindow.nativeElement.open();
                    break;
                case "share-option":
                    //communicate to nav-menu to open sharelayer
                    this.openShareLayer.next(layer.mapcoreProps.idFromSavedLayer ? layer.mapcoreProps.idFromSavedLayer : layer.mapcoreProps.parentId);
                    break;
                case "copy-option":
                    this.mapRef.nativeElement.LayerService.copyEsriLayer(esriLayer);
                    break;
                case "export-excel-option":
                    exportLayerRef.layerId = esriLayer.mapcoreProps.parentId;
                    rootQuery = this.mapRef.nativeElement.LayerService.modifyQueryForExport(esriLayer.mapcoreProps.parentQuery, esriLayer.mapcoreProps.query);
                    if (esriLayer.mapcoreProps.isExternal) {
                        this.exportExcelParams = { layerId: esriLayer.mapcoreProps.parentId, query: rootQuery };
                    }
                    else {
                        let layerColumns = esriLayer.mapcoreProps.columns, fieldNames = [];
                        if (layerColumns) {
                            layerColumns = layerColumns.sort((a, b) => {
                                if (a.databaseColumnOrder > b.databaseColumnOrder) {
                                    return 1;
                                }
                                else if (a.databaseColumnOrder < b.databaseColumnOrder) {
                                    return -1;
                                }
                                return 0;
                            });
                            fieldNames = layerColumns.map(x => x.name);
                        }
                        this.exportExcelParams = { layerId: esriLayer.mapcoreProps.parentId, query: rootQuery, fieldNames: fieldNames };
                    }
                    this.mapRef.nativeElement.LayerService.getLayerChildTables(esriLayer.mapcoreProps.parentId).then(childTables => {
                        if (childTables && childTables.length > 0) {
                            this.childTables = childTables.map(t => {
                                return Object.assign({}, t, { checked: true });
                            });
                            document.getElementById('exportLayerLegend').innerHTML = esriLayer.mapcoreProps.name;
                            document.getElementById('exportLayerFilter').open();
                        }
                        else {
                            exportLayerRef.ExportService.exportToExcelAndOpenUrl(this.exportExcelParams);
                        }
                    });
                    break;
                case "export-shapefile-option":
                    exportLayerRef.layerId = esriLayer.mapcoreProps.parentId;
                    const props = esriLayer.mapcoreProps;
                    if (props.parentQuery) {
                        rootQuery.subqueries.push(props.parentQuery);
                    }
                    if (props.query) {
                        rootQuery.subqueries.push(props.query);
                    }
                    let geometries = null;
                    if (esriLayer && esriLayer.type && esriLayer.type.toLowerCase() === 'graphics') {
                        geometries = yield this.mapRef.nativeElement.LayerService.getLayerGeometry(esriLayer);
                    }
                    const exportShapeFileParams = {
                        name: props.name,
                        columns: props.columns,
                        tables: props.tables,
                        query: rootQuery,
                        geometries: geometries ? geometries.map(x => x.toJSON()) : null
                    };
                    exportLayerRef.ExportService.exportToShapeFileAndOpenUrl(exportShapeFileParams);
                    break;
                case "filter-option":
                    this.filteringLayer = esriLayer;
                    this.layerFilter.nativeElement.layerId = null; //Force a reset of the layerId
                    this.layerFilter.nativeElement.layerId = layerId;
                    this.layerFilterWindow.nativeElement.open();
                    break;
                case "data-dictionary-option":
                    let dataDictionaryUrl = environmentMIQ.internalURLBase + '/DataDictionary/';
                    if (esriLayer.mapcoreProps.metaTableId) {
                        dataDictionaryUrl += '#/home/tableView/' + esriLayer.mapcoreProps.metaTableId;
                    }
                    window.open(dataDictionaryUrl);
                    break;
                case "data-table-option":
                    this.openDataTable(esriLayer);
                    break;
                case "min-max-option":
                    this.minMaxScaleWindow.nativeElement.open();
                    this.minMaxScale.nativeElement.uniqueLayerId = esriLayer.id;
                    break;
                case "labels-option":
                    this.layerLabelsWindow.nativeElement.open();
                    this.layerLabels.nativeElement.uniqueLayerId = esriLayer.id;
                    break;
                case "delete-option":
                    if (esriLayer.parent && esriLayer.parent != this.mapRef.nativeElement.map) {
                        this.mapRef.nativeElement.map.allLayers.find(layer => layer == esriLayer.parent).remove(esriLayer);
                    }
                    else {
                        this.mapRef.nativeElement.map.remove(esriLayer);
                    }
                    if (this.dataTable && this.dataTable.nativeElement.opened) {
                        this.dataTable.nativeElement.close(layerId);
                    }
                    break;
                case "spatial-query-option":
                    this.layerSpatialQueryWindow.nativeElement.open();
                    this.layerSpatial.nativeElement.primaryLayers = [esriLayer].reverse();
                    this.layerSpatial.nativeElement.joinedLayers = this.mapLayers.filter(l => l.id !== esriLayer.id).filter(l => l.title !== "Identify").reverse();
                    this.layerSpatial.nativeElement.reset();
                    break;
                case "renew-spatial-query-option":
                    if (esriLayer.mapcoreProps.spatialQueryParams !== undefined) {
                        const params = esriLayer.mapcoreProps.spatialQueryParams;
                        const results = yield this.mapRef.nativeElement.SpatialQueryService.renewQuery(params, esriLayer.id);
                        this.spatialNotification(results);
                    }
                    break;
                case "buffer-layer-option":
                    this.buffer.nativeElement.layer = esriLayer;
                    this.buffer.nativeElement.mapLayers = this.mapLayers.map((layer) => {
                        return {
                            id: layer.id,
                            name: layer.mapcoreProps.name
                        };
                    });
                    this.buffer.nativeElement.mapView = this.mapRef.nativeElement.mapView;
                    this.bufferWindow.nativeElement.windowTitle = "Buffer Layer";
                    this.bufferWindow.nativeElement.open();
                    break;
                case "zoom-option":
                    this.mapRef.nativeElement.zoomToLayer(layerId, 18);
                    break;
                case "theme-editor-option":
                    this.themeEditor.nativeElement.layerId = layerId;
                    this.themeEditorWindow.nativeElement.open();
                    break;
                case "details":
                    target.dispatchEvent(new CustomEvent('opendetails', { bubbles: true, cancelable: true }));
                    break;
                case "add-record-option":
                    this.openEditorWindow('add', layerId);
                    break;
                default:
                    break;
            }
            this.dropdownToggle(event.target, event, true);
        });
    }
    groupOptionSelected(event) {
        const target = event.detail.target;
        const buttonClass = target.className.split(' ').find(className => className.endsWith('-option'));
        switch (buttonClass) {
            case "delete-option":
                this.legendRef.nativeElement.removeGroup(event.detail.groupLayerId);
                break;
            case "split-theme-editor-option":
                this.themeEditor.nativeElement.layerId = event.detail.groupLayerId;
                this.themeEditorWindow.nativeElement.open();
                break;
            default:
                break;
        }
    }
    exportLayerWithChildTables() {
        return __awaiter(this, void 0, void 0, function* () {
            const exportLayerRef = this.exportLayer.nativeElement.getComponentReference();
            this.exportExcelParams.childTableIds = this.childTables.filter(t => t.checked).map(t => t.tableId);
            this.exportExcelParams.includeLayerChildren = true;
            this.isLoading = true;
            document.getElementById('exportLayerFilter').close();
            try {
                yield exportLayerRef.ExportService.exportToExcelAndOpenUrl(this.exportExcelParams);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.isLoading = false;
            }
        });
    }
    closeExportLayerFilterWindow() {
        document.getElementById('exportLayerFilter').close();
    }
    optionsAttached(event) {
        if (event.detail.target.parentElement.classList.contains('item')) {
            // Filter option buttons here
            // Setup dropdown menu click event
            let compScope = this;
            event.detail.target.getElementsByClassName('layer-options-button')[0].addEventListener('click', function (event) { compScope.dropdownToggle(this, event); });
            const layer = this.mapRef.nativeElement.map.findLayerById(event.detail.layerId);
            let removeClasses = [];
            switch (layer.type) {
                case 'graphics':
                    removeClasses = ['copy-option', 'data-dictionary-option', 'data-table-option',
                        'export-excel-option', 'filter-option', 'labels-option',
                        'spatial-query-option', 'theme-editor-option', 'details'];
                    if (layer.graphicLayer && layer.graphicLayer === 'text') {
                        removeClasses.push('export-shapefile-option');
                    }
                    break;
                case 'feature':
                    removeClasses = ['buffer-layer-option', 'copy-option', 'data-dictionary-option', 'export-shapefile-option',
                        'export-excel-option', 'labels-option', 'share-option', 'theme-editor-option'];
                    break;
                case 'map-image':
                    break;
            }
            const renewOption = event.detail.target.getElementsByClassName('renew-spatial-query-option');
            if (!layer.mapcoreProps || !layer.mapcoreProps.spatialQueryParams) {
                renewOption[0].style.display = 'none';
            }
            else {
                renewOption[0].style.display = null;
            }
            const permissions = this.navMenuRef.authRef.nativeElement.permissions.value;
            const addPermissions = [];
            if (layer.mapcoreProps && layer.mapcoreProps.permissions) {
                addPermissions.push(...layer.mapcoreProps.permissions.filter(p => p.action === 'IR').map(p => p.name));
            }
            if (!addPermissions.filter(ap => permissions.includes(ap)).length) {
                removeClasses.push('add-record-option');
            }
            for (const cls of removeClasses) {
                const els = event.detail.target.getElementsByClassName(cls);
                if (els && els.length) {
                    Array.from(els).forEach(el => el.remove());
                }
            }
            if (event.detail.target.getElementsByTagName('nav')[0].childElementCount === 0) {
                event.detail.target.style.display = 'none';
            }
            this.setFilterButtonColor(event.detail.target, layer);
            this.layerUpdates.push({
                layerId: event.detail.layerId,
                handler: setInterval((layerId, legendElement) => {
                    const layer = this.mapRef.nativeElement.map.findLayerById(layerId);
                    if (layer) {
                        this.setFilterButtonColor(legendElement, layer);
                    }
                    else {
                        const lui = this.layerUpdates.findIndex(lu => lu.layerId === layerId);
                        clearInterval(this.layerUpdates[lui].handler);
                        this.layerUpdates.splice(lui, 1);
                    }
                }, 100, event.detail.layerId, event.detail.target)
            });
        }
    }
    setFilterButtonColor(legendElement, layer) {
        if (layer && layer.mapcoreProps && layer.mapcoreProps.query) {
            var filterButton = Array.from(legendElement.getElementsByClassName('filter-option')).shift();
            if (filterButton) {
                var query = layer.mapcoreProps.query;
                if ((query.subqueries && query.subqueries.length) || query.field
                    || (query.childTableRecord && query.childTableRecord.childTableName)
                    || (query.joinRecord && query.joinRecord.tableName)) {
                    filterButton.classList.add('icon-ui-blue');
                }
                else {
                    filterButton.classList.remove('icon-ui-blue');
                }
            }
        }
    }
    spatialNotification(results) {
        if (results && results.length && results.length > 0) {
            for (const result of results.reverse()) {
                let message = '', level = 3;
                if (result.resultCount > 0) {
                    message = 'Execution successful.Matching Feature Count: ' + result.resultCount.toString();
                    level = 3;
                }
                else {
                    message = 'No matching features found.';
                    level = 4;
                }
                const applicationMessage = new CustomEvent('applicationMessage', { detail: { message: message, level: level, isPrivate: false }, composed: true });
                window.dispatchEvent(applicationMessage);
            }
        }
    }
    dropdownToggle(target, event, forceClose) {
        // todo: open menu up if to close to bottom
        if (!forceClose) {
            let allDrops = target.closest('.angular-tree-component').getElementsByClassName('dropdown-menu');
            for (let drop of Array.from(allDrops)) {
                let gear = drop.parentElement.getElementsByClassName("layer-options-button")[0];
                gear.classList.remove('dropped');
                drop.style.display = '';
            }
        }
        let gear = target.parentElement.getElementsByClassName("layer-options-button")[0];
        let drop = target.parentElement.getElementsByClassName("dropdown-menu")[0];
        if (drop) {
            let currentDisplay = drop.style.display;
            drop.style.display = currentDisplay === 'block' || forceClose ? '' : 'block';
            let gearPosition = gear.getBoundingClientRect();
            drop.style.left = `${gearPosition.left + 25}px`;
            drop.style.top = `${gearPosition.top}px`;
            let dropPosition = drop.getBoundingClientRect();
            if (dropPosition.bottom > window.innerHeight) {
                let difference = dropPosition.bottom - window.innerHeight;
                drop.style.top = `${gearPosition.top - difference}px`;
            }
            if (forceClose) {
                gear.classList.remove('dropped');
            }
            else {
                gear.classList.add('dropped');
            }
        }
        const restClickListener = (e) => {
            if (!e.target.classList.contains('dropdown-link')) {
                this.dropdownToggle(target, e, true);
                window.removeEventListener('click', restClickListener);
            }
        };
        event.stopPropagation();
        if (drop.style.display === 'block') {
            window.addEventListener('click', restClickListener);
        }
        else {
            window.removeEventListener('click', restClickListener);
        }
    }
    getLayerByUniqueId(layerId) {
        return this.mapLayers.filter(l => l.id === layerId)[0];
    }
    get mapLayers() {
        const mapLayers = [];
        for (const layer of this.mapRef.nativeElement.map.layers.toArray()) {
            if (layer.type === 'group') {
                for (const sub of layer.layers) {
                    mapLayers.push(sub);
                }
            }
            else {
                mapLayers.push(layer);
            }
        }
        return mapLayers;
    }
    openSaveMapWindow() {
        this.saveMapWindow.nativeElement.open();
    }
    openImportExternalMapWindow() {
        this.importExternalMapWindow.nativeElement.open();
    }
    openSpatialQueryWindow() {
        this.layerSpatialQueryWindow.nativeElement.open();
        this.layerSpatial.nativeElement.primaryLayers = [];
        this.layerSpatial.nativeElement.joinedLayers = [];
        this.layerSpatial.nativeElement.reset();
    }
    closeImportExternalMapWinodw() {
        this.importExternalMapWindow.nativeElement.close();
    }
    openMapPrintWindow() {
        this.printStatus(true);
    }
    closePrint() {
        this.printStatus(false);
    }
    openFeatureBufferWindow(e) {
        this.buffer.nativeElement.geometry = e.detail;
        this.bufferWindow.nativeElement.windowTitle = "Buffer Feature";
        this.bufferWindow.nativeElement.open();
    }
    onLargerImageRequest(event) {
        if (!event || !event.detail || !Array.isArray(event.detail)) {
            return;
        }
        const images = event.detail;
        this.imageWindow.nativeElement.open();
        this.imageGallery.nativeElement.imageSources = images;
    }
    onLargerVideoRequest(event) {
        if (!event || !event.detail) {
            return;
        }
        const video = event.detail;
        this.imageWindow.nativeElement.open();
        this.imageGallery.nativeElement.videoSource = video;
    }
    onSymbolChange(event) {
        if (!event.detail.symbolIsColorRamp) {
            this.symbolEditorWindow.nativeElement.open();
            this.symbolEditor.nativeElement.uniqueLayerId = event.detail.uniqueLayerId;
        }
        else {
            this.themeEditorWindow.nativeElement.open();
            this.themeEditor.nativeElement.layerId = event.detail.uniqueLayerId;
        }
    }
    printStatus(active) {
        this.printActive = active;
        this.print.nativeElement.active = active;
        if (active) {
            this.printOpen = true;
            this.printReady = false;
        }
        this.disableIdentify({ key: 'print', disable: active });
    }
    disableIdentify(value) {
        if (value.disable) {
            this.identifyWindow.nativeElement.deactivate();
            this.identifyDisabledFor.push(value.key);
        }
        else {
            this.identifyDisabledFor.splice(this.identifyDisabledFor.indexOf(value.key), 1);
            if (this.identifyDisabledFor.length < 1) {
                this.identifyWindow.nativeElement.activate();
            }
        }
    }
    toggleCollapsePrintArea() {
        this.printOpen = !this.printOpen;
        if (!this.printOpen) {
            this.identifyWindow.nativeElement.activate();
        }
        else {
            this.identifyWindow.nativeElement.deactivate();
            this.printReady = false;
        }
    }
    onResetPress() {
        this.identifyWindow.nativeElement.showIdentify = false;
        this.printStatus(false);
        this.saveLayerWindow.nativeElement.close();
        this.saveMapWindow.nativeElement.close();
        this.shareMapWindow.nativeElement.close();
        this.unshareMapWindow.nativeElement.close();
        this.layerFilterWindow.nativeElement.close();
        this.minMaxScaleWindow.nativeElement.close();
        this.layerLabelsWindow.nativeElement.close();
        this.layerSpatialQueryWindow.nativeElement.close();
        this.themeEditorWindow.nativeElement.close();
        this.symbolEditorWindow.nativeElement.close();
        this.globalFilterWindow.nativeElement.close();
        this.filterLayerOptionsWindow.nativeElement.close();
        this.importExternalMapWindow.nativeElement.close();
        this.bufferWindow.nativeElement.close();
        this.imageWindow.nativeElement.close();
        this.exportMapWindowRef.nativeElement.close();
    }
    onResetConfirm() {
        this.dataTable.nativeElement.closeAll();
    }
    userSettingsChange(e) {
        this.defaults = [...e.counties.value, ...e.districts.value];
    }
    openGlobalFilter(e) {
        e.preventDefault();
        this.globalFilterWindow.nativeElement.open();
    }
    mapOpened(e) {
        this.globalFilterWindow.nativeElement.open();
    }
    openMergeMap() {
        this.navMenuRef.mergeMap();
    }
    openExportMap() {
        this.exportMapWindowRef.nativeElement.open();
    }
    openVideolog(e) {
        this.openVL.next(e.detail);
    }
    openStreetView(e) {
        this.openSV.next(e.detail);
    }
    openCompactLegend() {
        const legendArea = document.getElementById('legendArea');
        const headerArea = document.getElementById('mapInfoContainer');
        this.isCompact = true;
        this.mapInfoContainerRef.nativeElement.isCompact = true;
        this.addDraggableLegendProps(legendArea, headerArea);
    }
    closeCompactLegend() {
        this.isCompact = false;
        this.mapInfoContainerRef.nativeElement.isCompact = false;
        this.resetLegendArea();
    }
    resetLegendArea() {
        const legendArea = document.getElementById('legendArea');
        const mapInfoContainer = document.getElementById('mapInfoContainer');
        legendArea.style.width = null;
        legendArea.style.height = null;
        legendArea.style.left = null;
        legendArea.style.top = null;
        legendArea.style.boxShadow = null;
        mapInfoContainer.onmousedown = null;
        mapInfoContainer.style.cursor = 'default';
    }
    addDraggableLegendProps(elmnt, header) {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        header.style.cursor = 'grab';
        header.onmousedown = dragMouseDown;
        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            header.style.cursor = 'grabbing';
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }
        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            // stops from moving off screen
            let elmntTop = elmnt.style.top.substring(0, elmnt.style.top.indexOf('p'));
            let elmntLeft = elmnt.style.left.substring(0, elmnt.style.left.indexOf('p'));
            if (elmntTop < 0) {
                elmnt.style.top = '0px';
            }
            if (elmntTop >= window.innerHeight - elmnt.offsetHeight) {
                elmnt.style.top = (window.innerHeight - elmnt.offsetHeight) + "px";
            }
            if (elmntLeft < 0) {
                elmnt.style.left = '0px';
            }
            if (elmntLeft >= window.innerWidth - elmnt.offsetWidth) {
                elmnt.style.left = (window.innerWidth - elmnt.offsetWidth) + "px";
            }
        }
        function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
            header.style.cursor = 'grab';
        }
    }
    openAllDataTables() {
        //for each applicable layer in maplayers, open its data-table
        let i = 1;
        for (let layer of this.mapLayers) {
            if (layer.type === 'feature' || layer.type === 'map-image') {
                setTimeout(() => {
                    this.openDataTable(layer);
                }, i * 20);
            }
            i++;
        }
    }
    openDataTable(layer) {
        if (!this.dataTableLayerUniqueId) {
            this.layerFilter.nativeElement.addEventListener('onapply', (data) => {
                if (data.detail && data.detail.esriLayer && data.detail.esriLayer.id === this.dataTableLayerUniqueId && this.dataTable.nativeElement.mapcoreProps) {
                    this.dataTable.nativeElement.mapcoreProps.query = data.detail.esriLayer.mapcoreProps.query;
                    this.dataTable.nativeElement.mapcoreProps = Object.assign({}, data.detail.esriLayer.mapcoreProps);
                }
            });
        }
        this.dataTableLayerUniqueId = layer.id;
        let mcProps = Object.assign({}, layer.mapcoreProps);
        mcProps.isExternal = layer.type === 'feature' ? true : false;
        let newLayerId;
        if (mcProps.idFromSavedMap) {
            newLayerId = mcProps.idFromSavedMap;
        }
        else {
            newLayerId = mcProps.parentId !== null ? mcProps.parentId : mcProps.Id || mcProps.idFromSavedLayer;
        }
        if (newLayerId && !(this.dataTableArr.findIndex(x => x.layerId === newLayerId.toString()) > -1)) {
            const dataTableArrInfo = { name: mcProps.name, layerId: this.dataTableLayerUniqueId };
            this.dataTableArr.push(dataTableArrInfo);
            mcProps.dataTableArr = this.dataTableArr;
        }
        mcProps.esriLayerId = layer.id;
        this.dataTable.nativeElement.mapcoreProps = mcProps;
        this.dataTable.nativeElement.opened = true;
    }
    openShareMap(maps) {
        this.shareMapWindow.nativeElement.open();
        this.shareMap.nativeElement.map = maps !== undefined ? maps : this.mapRef.nativeElement.mapView.mapcoreViewProps;
    }
    onImportShapefileDrop(event) {
        this.isLoading = true;
    }
    onImportShapefileDone(event) {
        this.isLoading = false;
    }
    identifyFeatureUpdated(feature) {
        if (feature && feature.sourceLayer) {
            const layer = feature.sourceLayer ? feature.sourceLayer : feature.layer;
            const permissions = this.navMenuRef.authRef.nativeElement.permissions.value;
            const addPermissions = [];
            if (layer.mapcoreProps && layer.mapcoreProps.permissions) {
                addPermissions.push(...layer.mapcoreProps.permissions.filter(p => p.action === 'UR' || p.action === 'DR').map(p => p.name));
            }
            if (addPermissions.filter(ap => permissions.includes(ap)).length || this.canEditOwn(layer.mapcoreProps.parentId || layer.mapcoreProps.id, feature)) {
                this.recordEditorButtonRef.nativeElement.style.display = null;
            }
            else {
                this.recordEditorButtonRef.nativeElement.style.display = 'none';
            }
            layer.mapcoreProps.permissions = layer.mapcoreProps.permissions ? layer.mapcoreProps.permissions.filter(p => p.action !== 'OWN') : [];
            if (this.canEditOwn(layer.mapcoreProps.parentId || layer.mapcoreProps.id, feature)) {
                layer.mapcoreProps.permissions.push({
                    action: "OWN",
                    name: "Owner"
                });
            }
        }
        else if (feature && feature.layer) {
            this.recordEditorButtonRef.nativeElement.style.display = 'none';
        }
    }
    canEditOwn(layerId, feature) {
        var retVal = false;
        var config = environmentMIQ.personalRecordEditorConfigs.find(config => config.layerId === layerId);
        if (feature && config) {
            var attribute = feature.attributes.find(attr => attr.columnName === config.userField);
            if (attribute && attribute.value !== undefined && attribute.value !== null) {
                switch (config.userFieldType) {
                    case "email":
                        retVal = attribute.value.toString().toLowerCase() === this.user.emailAddress.toLowerCase();
                        if (!retVal) {
                            retVal = attribute.value.toString().toLowerCase() === this.user.emailAddress.split("@")[0].toLowerCase();
                        }
                        break;
                    case "id":
                        retVal = attribute.value === this.user.id;
                        break;
                }
            }
        }
        return retVal;
    }
    openEditorWindow(mode, layerId, objectId) {
        if (!layerId && !objectId && this.identifyWindow.nativeElement.currentFeature && this.identifyWindow.nativeElement.currentFeature.sourceLayer) {
            layerId = this.identifyWindow.nativeElement.currentFeature.sourceLayer.parent.id;
            objectId = this.identifyWindow.nativeElement.currentFeature.attributes.find(a => a.columnName.toLowerCase() === 'objectid').value;
        }
        this.recordEditorRef.nativeElement.activate(layerId, objectId);
        this.recordEditorWindowRef.nativeElement.windowTitle = `${mode === 'add' ? 'Add' : 'Edit'} Record`;
        this.recordEditorWindowRef.nativeElement.open();
    }
}
